/**
 * @generated SignedSource<<a66f3b94e0951920adc3b289ab4e7221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedRedirect_charge$data = {
  readonly redirectUrl: string | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkCompletedRedirect_charge";
};
export type PaymentLinkCompletedRedirect_charge$key = {
  readonly " $data"?: PaymentLinkCompletedRedirect_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedRedirect_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedRedirect_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "690b5a12bad76fc4f39e7a3c32c3125e";

export default node;
